'use client';

function ProductRecommendationsSkeleton() {
  const placeholders = Array.from({ length: 5 });

  return (
    <section className="mt-12">
      <div className="h-6 w-48 rounded bg-gray-200 animate-pulse" />
      <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-4 lg:grid-cols-5">
        {placeholders.map((_, index) => (
          <div
            key={index}
            className="h-44 rounded-xl bg-gray-100 animate-pulse md:h-52 lg:h-56"
          />
        ))}
      </div>
    </section>
  );
}

export default ProductRecommendationsSkeleton;
